import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import CategoriesPage from "../pages/categories/page";
import CategoryDetailPage from "../pages/categories/detail/page";
import ProvidersPage from "../pages/providers/page";
import ProviderDetailPage from "../pages/providers/detail/page";
import VideoDetailPage from "../pages/products/video/page";
import KitDetailPage from "../pages/products/kit/page";
import LoginPage from "../pages/auth/login/page";
import RegisterPage from "../pages/auth/register/page";
import ConsumerMypagePage from "../pages/mypage/consumer/page";
import ProviderMypagePage from "../pages/mypage/provider/page";
import SellPage from "../pages/sell/page";
import SellVideoPage from "../pages/sell/video/page";
import SellKitPage from "../pages/sell/kit/page";
import CoursesPage from "../pages/courses/page";
import MaterialsPage from "../pages/materials/page";
import FaqPage from "../pages/faq/page";
import AdminPage from "../pages/admin/page";
import MessagesPage from "../pages/messages/page";
import ContactPage from "../pages/contact/page";
import ReviewsPage from "../pages/reviews/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import GuidePage from "../pages/guide/page";
import PricingPage from "../pages/pricing/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/categories", element: <CategoriesPage /> },
  { path: "/categories/:id", element: <CategoryDetailPage /> },
  { path: "/providers", element: <ProvidersPage /> },
  { path: "/providers/:id", element: <ProviderDetailPage /> },
  { path: "/courses", element: <CoursesPage /> },
  { path: "/courses/:id", element: <VideoDetailPage /> },
  { path: "/materials", element: <MaterialsPage /> },
  { path: "/materials/:id", element: <KitDetailPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/mypage", element: <ConsumerMypagePage /> },
  { path: "/mypage/provider", element: <ProviderMypagePage /> },
  { path: "/sell", element: <SellPage /> },
  { path: "/sell/video", element: <SellVideoPage /> },
  { path: "/sell/kit", element: <SellKitPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/messages", element: <MessagesPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/guide", element: <GuidePage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
